import { useAuth } from "@clerk/clerk-react";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect, useState } from "react";
import { BannerCouponName } from "schemas/dashboard";

import { fetcherAuth } from "utils/api";
import { titleCase } from "utils/string";

import BlackFridayPromo from "./Promos/BlackFridayPromo";
import EndOfYearSale from "./Promos/EndOfYearSale";
import MoneyBackGuaranteePromo from "./Promos/MoneyBackGuranteePromo";
import NewSubscriberPromo from "./Promos/NewSubscriberPromo";
import PastDueBanner from "./Promos/PastDueBanner";
import { useCountDown } from "./useCountdown";

const HomeBanner = () => {
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription, setSubscription, setHasPastDue } =
    useContext(SubscriptionContext);
  const { hasPromoDate } = useCountDown();

  const [pastDuePlan, setPastDuePlan] = useState("");

  const fetchUser = async () => {
    const res = await fetcherAuth(getToken, `/api/organization/auth/user`);
    setSubscription(res.subscription);
  };

  const fetchPastDuePlan = async () => {
    const res = await fetcherAuth(
      getToken,
      `/api/organization/${currentOrg?.id}/payments/past-due-plan-name`,
    );
    if (res.planName) {
      setPastDuePlan(titleCase(res.planName));
      setHasPastDue(true);
    }
  };

  useEffect(() => {
    if (!hasPromoDate) {
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPromoDate]);

  useEffect(() => {
    if (currentOrg?.id) {
      fetchPastDuePlan();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  if (pastDuePlan) {
    return <PastDueBanner pastDuePlan={pastDuePlan} />;
  } else if (
    subscription?.bannerPromoCode?.couponName === BannerCouponName.black_friday
  ) {
    return <BlackFridayPromo />;
  } else if (
    subscription?.bannerPromoCode?.couponName ===
    BannerCouponName.end_of_year_sale
  ) {
    return <EndOfYearSale />;
  } else if (
    subscription?.bannerPromoCode?.couponName ===
    BannerCouponName.new_subscriber
  ) {
    return <NewSubscriberPromo />;
  } else if (
    subscription?.bannerPromoCode?.couponName ===
    BannerCouponName.money_back_guarantee
  ) {
    return <MoneyBackGuaranteePromo />;
  } else {
    return <></>;
  }
};

export default HomeBanner;
